/* jshint -W071 */ // TODO: fix maxstatements violation?
angular.module('core')
  .service('studentApi', [
    'cancelableResourceFactory',
    'cancelableResourceManager',
    '$state',
    'standardsApi',
    'highlightsApi',
    'transformResponse',
    'nameFilter',
    'timeframe',
    'exportService',
    'lcidConstants',
    function (
        $cancelableResourceFactory,
        $cancelableResourceManager,
        $state,
        $standardsApi,
        $highlightsApi,
        $transformResponse,
        $nameFilter,
        $timeframe,
        $exportService,
        lcidConstants)
    {
      var self = this;

      var studentSettingsMapping = function (body) {
          var student = JSON.parse(body);
          student.type = 'student';
          return student;
      };

      var studentPasswordsMapping = function (body) {
          var passwords = JSON.parse(body).data;
          passwords.type = 'studentsPasswords';
          passwords.picture_images[''].name = 'None';
          return passwords;
      };

      var studentClassroomMapping = function (classroom) {
          return classroom;
      };

      self.studentnavigationMapping = function (student) {
          student.name = $nameFilter(student);
          student.nickName = "";
          student.congratulate = student.status === 1;
          student.warn = student.status === 2;

      };
      self.getStorageContext = function () {
        try {
          var contextData = localStorage.getItem('context');
          return contextData ? JSON.parse(contextData) : {};
        } catch (e) {
          console.warn('Invalid context in localStorage:', e);
          return {};
        }
      };

      var studentReportingMapping = function (student) {
          student.name = $nameFilter(student);
          student.activeStudents = student.count_active_students;
          student.averageMonthlySessionTime = student.average_monthly_session_time;
          student.extendedUsage = student.percent_usage_extended_hours;
          student.lessonsCompletedThisYear = student.count_lessons_completed;
          student.averageGrowth = student.percent_growth;
          student.warn = student.warn;
          student.congratulate = student.congratulate;
          student.status_reason_codes = student.status_reason_codes;
          return student;
      };

      var StudentSettings = $cancelableResourceFactory.createCacheableResource(null, '/m/student/:id/settings', {id: '@id'}, {
          get: {
              transformResponse: studentSettingsMapping,
              url: '/m/student/:id/settings',
              method: 'GET'
          }
      });

      var StudentsPasswords = $cancelableResourceFactory.createCacheableResource(null, '/m/student/:id/students_info_with_passwords', {
          id: '@id'
      }, {
          get: {
              transformResponse: studentPasswordsMapping,
              url: '/m/student/:id/students_info_with_passwords',
              method: 'GET'
          }
      });

      //
      var StudentPasswordsUpdate = $cancelableResourceFactory.createCacheableResource(null, '/m/student/:id/student_password', {
          id: '@id'
      });

      var StudentNavigation = $cancelableResourceFactory.createCacheableResource('StudentNavigation', '/n/districts/:districtId/students', {
          id: '@id'
      }, {
          query: {
              cache: true,
              url: '/n/districts/:districtId/students',
              method: 'GET',
              isArray: true,
              transformResponse: function (body) {
                  return $transformResponse.transformNavigationQuery('student', body, self.studentnavigationMapping);
              }
          },
          get: {
              cache: true,
              url: '/n/districts/:districtId/students?student_id=:studentId&classroom_id=:classroomId',
              method: 'GET',
              isArray: false,
              transformResponse: function (body) {
                  return $transformResponse.transformNavigationGet('student', body, self.studentnavigationMapping);
              }
          }
      });

      var ConsumerStudentNavigation = $cancelableResourceFactory.createCacheableResource('ConsumerStudentNavigation', '/n/districts/:districtId/guardians/:customerId/students', {
          id: '@id'
      }, {
          query: {
              cache: true,
              url: '/n/districts/:districtId/guardians/:customerId/students',
              method: 'GET',
              isArray: true,
              transformResponse: function (body) {
                  return $transformResponse.transformNavigationQuery('student', body, self.studentnavigationMapping);
              }
          },
          get: {
              cache: true,
              url: '/n/districts/:districtId/guardians/:customerId/students?student_id=:studentId',
              method: 'GET',
              isArray: false,
              transformResponse: function (body) {
                  return $transformResponse.transformNavigationGet('student', body, self.studentnavigationMapping);
              }
          }
      });

      var queryForTeacherUrl = '/r/districts/:districtId/teachers/:teacherId/students';
      var queryForClassroomUrl = '/r/districts/:districtId/classrooms/:classroomId/overview';
      var queryForStudentUrl = '/r/districts/:districtId/students/:studentId/overview';
      var studentUsageUrl = '/r/districts/:districtId/students/:studentId/usage';

      var StudentReporting = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/teachers/:teacher_id/students', {
          id: '@id'
      }, {
          queryForTeacher: {
              url: queryForTeacherUrl,
              method: 'GET',
              isArray: true,
              transformResponse: function (body, headersGetter, status) {
                  return $transformResponse.transformReportingQuery('student', body, studentReportingMapping, status);
              }
          },
          queryForClassroom: {
              url: queryForClassroomUrl,
              method: 'GET',
              isArray: false,
              transformResponse: function (body, headersGetter, status) {
                  try {
                      var jsonBody = JSON.parse(body);
                      if (status >= 300) {
                          return jsonBody;
                      }
                      $transformResponse.transformReportDates(jsonBody);
                      var overviewData = jsonBody.data;
                      _.forEach(overviewData.students_overview, function (studentOverview) {
                          studentOverview.type = 'student';
                          studentOverview.name = $nameFilter(studentOverview);
                          studentOverview.congratulate = studentOverview.status === 1;
                          studentOverview.warn = studentOverview.status === 2;
                          studentOverview.activityCompleted = studentOverview.status === 3;
                          studentOverview.groupCompleted = studentOverview.status === 4;
                      });
                      return overviewData;
                  }
                  catch (e) {
                      console.error('Overview Transform Error:', e.message);
                      return {};
                  }
              }
          },
          queryForStudent: {
              url: queryForStudentUrl,
              method: 'GET',
              isArray: false,
              transformResponse: $transformResponse.transformResponseAndReportDates
          },
          getUsage: {
              url: studentUsageUrl,
              method: 'GET',
              isArray: false,
              transformResponse: function (body) {
                  var initial = {
                      usageMinutes: {
                          data: [],
                          xAxisLabels: []
                      },
                      lessons: {
                          data: [],
                          xAxisLabels: []
                      }
                  };

                  try {
                      var jsonBody = JSON.parse(body);
                      $transformResponse.transformReportDates(jsonBody);
                      var usages = jsonBody.data.usage;
                      return _.reduce(usages, function (result, usage) {
                          var averageExtendedUsage = usage.average_extended_minutes;
                          var averageSchoolUsage = usage.average_usage_minutes - averageExtendedUsage;
                          result.usageMinutes.data.push([averageSchoolUsage, averageExtendedUsage]);
                          result.usageMinutes.xAxisLabels.push(usage.label);

                          result.lessons.data.push([usage.average_lessons]);
                          result.lessons.xAxisLabels.push(usage.label);
                          return result;
                      }, initial);
                  }
                  catch (e) {
                      console.error('Transform Error:', e.message);
                      return {};
                  }
              }
          },
          getFrequency: {
              url: '/r/districts/:districtId/students/frequency?teacher_id=:teacherId',
              method: 'GET',
              isArray: false,
              transformResponse: $transformResponse.transformResponseToJson
          },
          getBubbleGraph: {
              url: '/r/districts/:districtId/classrooms/:classroomId/students/bubblegraph',
              method: 'GET',
              isArray: false,
              transformResponse: function (body) {
                  return $transformResponse.transformBubbleGraph('student', body, studentReportingMapping);
              }
          }
      });

      var StudentUsage = $cancelableResourceFactory.createCacheableResource('StudentUsage', '/r/districts/:districtId/teachers/:teacher_id/students', {
          id: '@id'
      }, {
          getUsage: {
              url: studentUsageUrl,
              method: 'GET',
              cache: false,
              isArray: false,
              transformResponse: function (body) {
                  var initial = {
                      usageMinutes: {
                          data: [],
                          xAxisLabels: []
                      },
                      lessons: {
                          data: [],
                          xAxisLabels: []
                      }
                  };

                  try {
                      var jsonBody = JSON.parse(body);
                      $transformResponse.transformReportDates(jsonBody);
                      var usages = jsonBody.data.usage;
                      return _.reduce(usages, function (result, usage) {
                          var averageExtendedUsage = usage.average_extended_minutes;
                          var averageSchoolUsage = usage.average_usage_minutes - averageExtendedUsage;
                          result.usageMinutes.data.push([averageSchoolUsage, averageExtendedUsage]);
                          result.usageMinutes.xAxisLabels.push(usage.label);

                          result.lessons.data.push([usage.average_lessons]);
                          result.lessons.xAxisLabels.push(usage.label);
                          return result;
                      }, initial);
                  }
                  catch (e) {
                      console.error('Transform Error:', e.message);
                      return {};
                  }
              }
          }
      });

      // GET http://g2.dreambox.com/n/districts/{did}/teachers/{tid}/students/{sid}/classrooms
      var StudentClassrooms = $cancelableResourceFactory.createCacheableResource(null, '/n/districts/:did/teachers/:tid/students/:sid/classrooms', {}, {
          query: {
              url: '/n/districts/:did/teachers/:tid/students/:sid/classrooms',
              method: 'GET',
              isArray: true,
              transformResponse: function (body) {
                  return $transformResponse.transformStudentClassrooms('classroom', body, studentClassroomMapping);
              }
          }
      });


      /**************************************************************/
      /*                          Api                               */
      /**************************************************************/

      self.clearStudentNavigationCache = function () {
          StudentNavigation.$clearCache();
      };

      var getStudentUsageParams = function () {
          var params = _.pick($state.params, ['districtId', 'studentId']);
          params.by = $timeframe.getByData();

          var daysParam = $timeframe.getDaysParam();
          if (daysParam) {
            params.days = $timeframe.getDaysParam();
          } else {
            params.sy = $timeframe.getSchoolYear();
            params.fd = $timeframe.getFromDate();
            params.td = $timeframe.getToDate();
          }

          params.untilNow = true;
          params.school_id = $state.params.schoolId || undefined;
          params.teacher_id = $state.params.teacherId || undefined;
          params.classroom_id = $state.params.classroomId || undefined;
          return params;
      };

      self.getStudentUsageExportUrl = function () {
          var params = getStudentUsageParams();
          return $exportService.buildExportUrl(studentUsageUrl, params);
      };

      self.getStudentUsage = function () {
          var params = getStudentUsageParams();
          // This line called getUsage() in the StudentReporting cachedResource
          // var promises = StudentReporting.getUsage(params);

          // This line calls getUsage() in the StudentUsage cachedResource which has a parameter to never cache
          // To revert this change so usage will be cached, simply uncomment the above line and delete the following line
          // You can then delete the entire StudentUsage cachedResource
          // See bug #48405 for more information
          var promises = StudentUsage.getUsage(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      self.getStudentUsageForGuardian = function (callback) {
          var params = [];
          params.districtId = $state.params.studentDistrictId;
          params.studentId = $state.params.studentId;
          params.by = $timeframe.getByData();
          params.sy = $timeframe.getSchoolYear();
          params.fd = $timeframe.getFromDate();
          params.td = $timeframe.getToDate();
          params.untilNow = true;

          var promises = StudentUsage.getUsage(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getStudentsFrequency = function () {
          var params = _.pick($state.params, ['districtId', 'teacherId']);
          params.sy = $timeframe.getSchoolYear();
          params.fd = $timeframe.getFromDate();
          params.td = $timeframe.getToDate();
          params.untilNow = true;
          params.grade_id = $state.params.gradeId;
          params.school_id = $state.params.schoolId || undefined;

          var promises = StudentReporting.getFrequency(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      self.getStudentsClusterData = function (callback) {
          var params = _.pick($state.params, ['districtId', 'classroomId']);
          params.sy = $timeframe.getSchoolYear();
          params.fd = $timeframe.getFromDate();
          params.td = $timeframe.getToDate();
          params.untilNow = true;

          var promises = StudentReporting.getBubbleGraph(params);
          promises.$promise.then(callback);
          return promises;
      };

      var getStudentsReportingForTeacherParams = function () {
          var params = _.pick($state.params, ['districtId', 'teacherId', 'sort', 'order']);
          params.sy = $timeframe.getSchoolYear();
          params.fd = $timeframe.getFromDate();
          params.td = $timeframe.getToDate();
          params.untilNow = true;
          params.start = $state.current.data.page || undefined;
          params.teacher_id = $state.params.teacherId;
          params.grade_id = $state.params.gradeId;
          params.school_id = $state.params.schoolId || undefined;
          return params;
      };

      self.getStudentsReportingForTeacherExportUrl = function () {
          var params = getStudentsReportingForTeacherParams();
          return $exportService.buildExportUrl(queryForTeacherUrl, params);
      };

      self.getStudentsReportingForTeacher = function () {
          var params = getStudentsReportingForTeacherParams();
          var promises = StudentReporting.queryForTeacher(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      self.getStudentReportingForClassroomParams = function () {
          var params = _.pick($state.params, ['districtId', 'classroomId', 'sort', 'order']);
          // Sorting is done on the front end so all g2 classroom overview return are the same
          // We hardcode the sort and order parameters so that all sorts will use the same cached resource
          params.sort = 'name';
          params.order = 'asc';
          params.by = $timeframe.getByData();

          var daysParam = $timeframe.getDaysParam();
          if (daysParam) {
            params.days = $timeframe.getDaysParam();
          } else {
            params.sy = $timeframe.getSchoolYear();
            params.fd = $timeframe.getFromDate();
            params.td = $timeframe.getToDate();
          }

          params.untilNow = true;
          params.start = $state.current.data.page || undefined;
          params.grade_id = $state.params.gradeId;

          return params;
      };

      self.getStudentsReportingForClassroomExportUrl = function () {
          var params = self.getStudentReportingForClassroomParams();
          return $exportService.buildExportUrl(queryForClassroomUrl, params);
      };

      // @NOTE: Sample implementation of cancelableResourceFactory
      self.getStudentsReportingForClassroom = function () {
        var params = self.getStudentReportingForClassroomParams();
        return self.getClassroomOverview(params);
      };

      self.getClassroomOverview = function (params) {
          var promises = StudentReporting.queryForClassroom(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      var setDateParams = function (params) {
        var daysParam = $timeframe.getDaysParam();
        if (daysParam) {
          params.days = $timeframe.getDaysParam();
        } else {
          params.sy = $timeframe.getSchoolYear();
          params.fd = $timeframe.getFromDate();
          params.td = $timeframe.getToDate();
        }

        params.by = $timeframe.getByData();
        params.untilNow = true;
      };

      var getStudentsReportingForStudentParams = function () {
          var params = _.pick($state.params, ['districtId', 'studentId']);
          setDateParams(params);
          return params;
      };

      self.getStudentsReportingForStudentExportUrl = function () {
          var params = getStudentsReportingForStudentParams();
          return $exportService.buildExportUrl(queryForStudentUrl, params);
      };

      self.getStudentsReportingForStudent = function (districtId, studentId) {
          var params = {
            districtId: districtId,
            studentId: studentId
          };

          setDateParams(params);

          // Passing untilNow when today is chosen in picker
          if ($timeframe.isUntilNow()) {
              params.untilNow = true;
          }
          var promises = StudentReporting.queryForStudent(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      self.getStudentsReportingForGuardianStudent = function () {
          var params = [];
          params.districtId = $state.params.studentDistrictId;
          params.studentId = $state.params.studentId;
          params.sy = $timeframe.getSchoolYear();
          params.days = $timeframe.getDays();
          params.fd = $timeframe.getFromDate();
          params.td = $timeframe.getToDate();
          params.by = $timeframe.getByData();
          params.untilNow = true;

          var promises = StudentReporting.queryForStudent(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      self.getStudent = function (student_id, callback) {
          var params = _.pick($state.params, ['districtId', 'classroomId']);
          params.studentId = student_id;

          var promises = StudentNavigation.get(params);
          promises.$promise.then(callback);
          return promises;
      };

      /**
       * Get student
       *
       * District ID is taken from state parameters if not specified
       *
       * @param student_id User ID of student
       * @param district_id (Optional) District ID
       * @return {promise}
       */
      self.getStudentWithPromise = function (student_id, district_id) {
          var params = _.pick($state.params, ['districtId', 'classroomId']);
          params.studentId = student_id;
          if (district_id) {
            params.districtId = district_id;
          }

          var promises = StudentNavigation.get(params);
          return promises.$promise;
      };

      self.getStudents = function (callback) {
          var params = _.pick($state.params, ['districtId']);
          params.teacher_id = $state.params.teacherId;
          var context = self.getStorageContext();

          if (context && context.group) {
            // Return minimal promise-like object with empty data when in group context
            if (callback) {
              callback({});
            }

            return {
              $promise: {
                then: function(cb) {
                  if (cb) {
                    cb({});
                  }
                  return this;
                },
                catch: function () {
                  return this;
                },
                finally: function () {
                  return this;
                }
              },
              $resolved: true
            };
          }

          var promises = StudentNavigation.query(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getStudentsForTeacher = function (teacherId, schoolId, gradeId, callback) {
          var params = _.pick($state.params, ['districtId']);
          params.teacher_id = teacherId;
          params.school_id = schoolId;
          params.grade_id = gradeId;
          var context = self.getStorageContext();

          if (context && context.group) {
            // Return minimal promise-like object with empty data when in group context
            if (callback) {
              callback({});
            }

            return {
              $promise: {
                then: function(cb) {
                  if (cb) {
                    cb({});
                  }
                  return this;
                },
                catch: function () {
                  return this;
                },
                finally: function () {
                  return this;
                }
              },
              $resolved: true
            };
          }

        var promises = StudentNavigation.query(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getStudentsForClassroom = function (classroom_id, callback) {
          var params = _.pick($state.params, ['districtId']);
          params.classroom_id = classroom_id;
          params.grade_id = $state.params.gradeId;
          var context = self.getStorageContext();

          if (context && context.group) {
            // Return minimal promise-like object with empty data when in group context
            if (callback) {
              callback({});
            }

            return {
              $promise: {
                then: function(cb) {
                  if (cb) {
                    cb({});
                  }
                  return this;
                },
                catch: function () {
                  return this;
                },
                finally: function () {
                  return this;
                }
              },
              $resolved: true
            };
          }

        var promises = StudentNavigation.query(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getStudentsForClassroomWithPromise = function (classroom_id) {
          var params = _.pick($state.params, ['districtId']);
          params.classroom_id = classroom_id;
          params.grade_id = $state.params.gradeId;

          var promises = StudentNavigation.query(params);
          return promises.$promise;
      };

      self.getStudentsForGuardian = function (guardian_id, callback) {
          var params = _.pick($state.params, ['districtId']);
          params.customerId = $state.params.customerId;
          params.untilNow = true;

          var promises = ConsumerStudentNavigation.query(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getStudentGrades = function (studentId, astName) {
          var params = _.pick($state.params, ['districtId']);
          params.ast = astName;
          params.studentId = studentId;
          params.untilNow = true;

          var promises = $standardsApi.StudentGrades.get(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      self.getStudentGradesForGuardian = function (student_id, astName, callback) {
          var params = [];
          params.ast = astName;
          params.districtId = $state.params.studentDistrictId;
          params.studentId = student_id;
          params.untilNow = true;

          var promises = $standardsApi.StudentGrades.get(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getStudentDomains = function (studentId, gradeId) {
          var params = _.pick($state.params, ['districtId']);
          params.studentId = studentId;
          params.gradeId = gradeId;
          // get the last 6 weeks here so we don't have to set $state in the controller via bug: rm-49414
          params.by = 'week';
          params.fd = $timeframe.getFromDate(42);
          params.td = undefined; //We don't want a To date when we're using a numDays value for From date
          params.untilNow = true;

          var promises = $standardsApi.StudentDomains.get(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      self.getStudentDomainsForGuardian = function (student_id, grade_id, callback) {
          var params = [];
          params.districtId = $state.params.studentDistrictId;
          params.studentId = student_id;
          params.gradeId = grade_id;
          // get the last 6 weeks here so we don't have to set $state in the controller via bug: rm-49414
          params.by = 'week';
          params.fd = $timeframe.getFromDate(42);
          params.td = undefined; //We don't want a To date when we're using a numDays value for From date
          params.untilNow = true;

          var promises = $standardsApi.StudentDomains.get(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getStudentStandardsExportUrl = function () {
          var studentStandardsUrl = "/api/v1/districts/:districtId/reports/studentstandardsreport";
          var params = _.pick($state.params, ['districtId', 'studentId']);
          return $exportService.buildExportUrl(studentStandardsUrl, params, 'xls');
      };

      self.getStudentStandards = function (studentId, gradeId, domainId) {
          var params = _.pick($state.params, ['districtId']);
          params.studentId = studentId;
          params.gradeId = gradeId;
          params.domainId = domainId;
          // get the last 6 weeks here so we don't have to set $state in the controller via bug: rm-49414
          params.by = 'week';
          params.fd = $timeframe.getFromDate(42);
          params.td = undefined; //We don't want a To date when we're using a numDays value for From date
          params.untilNow = true;

          var promises = $standardsApi.StudentStandards.get(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      self.getStudentStandardsForGuardian = function (student_id, grade_id, domain_id) {
          var params = [];
          params.districtId = $state.params.studentDistrictId;
          params.studentId = student_id;
          params.gradeId = grade_id;
          params.domainId = domain_id;
          // get the last 6 weeks here so we don't have to set $state in the controller via bug: rm-49414
          params.by = 'week';
          params.fd = $timeframe.getFromDate(42);
          params.td = undefined; //We don't want a To date when we're using a numDays value for From date
          params.untilNow = true;

          var promises = $standardsApi.StudentStandards.get(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      self.getStudentStandardProgress = function (student_id, grade_id, domain_id, standard_id) {
          var params = _.pick($state.params, ['districtId']);
          params.studentId = student_id;
          params.gradeId = grade_id;
          params.domainId = domain_id;
          params.standardId = standard_id;
          // get the last 6 weeks here so we don't have to set $state in the controller via bug: rm-49414
          params.by = 'week';
          params.fd = $timeframe.getFromDate(42);
          params.td = undefined; //We don't want a To date when we're using a numDays value for From date
          params.untilNow = true;

          var promises = $standardsApi.StudentStandardProgress.get(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      self.getStudentStandardProgressForGuardian = function (student_id, grade_id, domain_id, standard_id, callback) {
          var params = [];
          params.districtId = $state.params.studentDistrictId;
          params.studentId = student_id;
          params.gradeId = grade_id;
          params.domainId = domain_id;
          params.standardId = standard_id;
          // get the last 6 weeks here so we don't have to set $state in the controller via bug: rm-49414
          params.by = 'week';
          params.fd = $timeframe.getFromDate(42);
          params.td = undefined; //We don't want a To date when we're using a numDays value for From date
          params.untilNow = true;

          var promises = $standardsApi.StudentStandardProgress.get(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getStudentClusterProgress = function (student_id, grade_id, domain_id, cluster_id) {
          var params = _.pick($state.params, ['districtId']);
          params.studentId = student_id;
          params.gradeId = grade_id;
          params.domainId = domain_id;
          params.clusterId = cluster_id;
          // get the last 6 weeks here so we don't have to set $state in the controller via bug: rm-49414
          params.by = 'week';
          params.fd = $timeframe.getFromDate(42);
          params.td = undefined; //We don't want a To date when we're using a numDays value for From date
          params.untilNow = true;

          var promises = $standardsApi.StudentClusterProgress.get(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };

      self.getStudentClusterProgressForGuardian = function (student_id, grade_id, domain_id, cluster_id, callback) {
          var params = [];
          params.districtId = $state.params.studentDistrictId;
          params.studentId = student_id;
          params.gradeId = grade_id;
          params.domainId = domain_id;
          params.clusterId = cluster_id;
          // get the last 6 weeks here so we don't have to set $state in the controller via bug: rm-49414
          params.by = 'week';
          params.fd = $timeframe.getFromDate(42);
          params.td = undefined; //We don't want a To date when we're using a numDays value for From date
          params.untilNow = true;

          var promises = $standardsApi.StudentClusterProgress.get(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getStudentData = function (student_id, callback) {
          var data = {};
          var params = _.pick($state.params, ['districtId']);
          params.student_id = student_id;
          params.sy = $timeframe.calculateCurrentReportingYear();
          params.untilNow = true;

          var promises = $highlightsApi.StudentHighlights.get(params);
          promises.$promise.then(function (highlights) {
              data = _.extend(data, highlights);
              callback(data);
          });
          return promises;
      };

      self.getStudentHighlights = function (params) {
          var data = {};

          var resource = $highlightsApi.StudentHighlights.get(params);

          return resource.$promise.then(function (highlights) {
              data = _.extend(data, highlights);
              return data;
          });
      };

      self.getStudentDataForGuardian = function (student_id, district_id) {
          var data = {};
          var params = [];
          params.student_id = student_id;
          params.districtId = district_id;
          params.sy = $timeframe.calculateCurrentReportingYear();
          params.untilNow = true;

          var resource = $highlightsApi.StudentHighlights.get(params);
          $cancelableResourceManager.addAndRemoveOnFinish(resource);

          return resource.$promise.then(function (highlights) {
              return _.extend(data, highlights);
          });
      };


      self.getStudentClassrooms = function (callback) {
          var params = {
              did: $state.params.districtId,
              tid: $state.params.teacherId,
              sid: $state.params.studentId
          };

          var promises = StudentClassrooms.query(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getYears = function (teacher_id, callback) {
          var data = {};
          var params = _.pick($state.params, ['districtId']);
          params.teacher_id = teacher_id;

          var promises = $highlightsApi.TeacherHighlights.get(params);
          promises.$promise.then(function (highlights) {
              data = _.extend(data, highlights);
              callback(data);
          });
          return promises;
      };

      self.getStudentSettings = function (sid, success, error) {
          var studentSettings = StudentSettings.get({id: sid});
          studentSettings.$promise.then(function (student) {
              student.type = 'student';
              success(student);
          });

          return studentSettings;
      };

      self.saveStudentSettings = function (item, success, error) {
          var student = new StudentSettings(item);
          student.$save([], success, error);
      };

      self.getStudentsPasswords = function (sid, success, error) {
          var studentsPasswords = StudentsPasswords.get({id: sid});
          studentsPasswords.$promise.then(function (passwords) {
              success(passwords);
          });

          return studentsPasswords;
      };

      self.saveStudentsPasswords = function (item, success, error) {
          var payload = {};
          payload.id = _.first(item.students).id;
          payload.text_password = _.first(item.students).text_password;
          payload.picture_password = _.first(item.students).picture_password;

          var student = new StudentPasswordsUpdate(payload);
          student.$save([], success, error);
      };

      self.getGradeLevels = function (classroom_id, callback) {
          var gradeLevels = [{
              name: 'PreK',
              value: 'PreK'
          }, {
              name: 'Kindergarten',
              value: 'Kindergarten'
          }, {
              name: '1st Grade',
              value: '1'
          }, {
              name: '2nd Grade',
              value: '2'
          }, {
              name: '3rd Grade',
              value: '3'
          }, {
              name: '4th Grade',
              value: '4'
          }, {
              name: '5th Grade',
              value: '5'
          }, {
              name: '6th Grade',
              value: '6'
          }, {
              name: '7th Grade',
              value: '7'
          }, {
              name: '8th Grade',
              value: '8'
          }, {
              name: '9th Grade',
              value: '9'
          }, {
              name: '10th Grade',
              value: '10'
          }, {
              name: '11th Grade',
              value: '11'
          }, {
              name: '12th Grade',
              value: '12'
          }];

          callback(gradeLevels);
      };

      self.getLearningEnviroments = function (student_id, callback) {
          var learningEnvironments = [{
              name: 'Primary',
              value: '0'
          }, {
              name: 'Intermediate',
              value: '1'
          }, {
              name: 'Middle School',
              value: '2'
          }];

          callback(learningEnvironments);
      };

      self.getStudentLanguages = function (student_id, callback) {
          var studentLanguages = [{
              name: 'English',
              value: String(lcidConstants.ENGLISH_US)
          }, {
              name: 'Spanish',
              value: String(lcidConstants.SPANISH_US)
          }];

          callback(studentLanguages);
      };

  }]);
/* jshint +W071 */
